<template>
    <div>
        <q-input-number
            outlined
            v-model="destAmount"
            type="number"
            input-class="input-bold ltr"
            color="primary"
            :label="$t('calculator.recipient_gets')"
            v-if="destCurrency"
            dir="ltr"
        >
            <template v-slot:append>
                <q-btn-dropdown
                    v-model="displayOrgCurrencies"
                    :label="destCurrency.symbol"
                    :icon="destCurrency.country"
                    flat
                    dense
                    dir="ltr"
                >
                    <q-list>
                        <q-item clickable v-close-popup v-for="dest_currency in dest_currencies" :key="dest_currency.acronym" @click="changeDestCurrency(dest_currency)">
                            <q-item-section avatar>
                                <q-icon :name="dest_currency.country" size="36px" />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{dest_currency.currency}}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </template>
            <tooltip
                closeable
                v-model="showTtip1"
                no-parent-event
                self="top left"
                anchor="bottom start"
                @closed="tooltipClosed"
                :close-label="$t('got_it')"
                v-if="!$q.localStorage.getItem('ttip_1')"
            >
                {{$t('calculator.you_can_also_type_here')}}
            </tooltip>
        </q-input-number>
        <q-skeleton type="QInput" v-else/>
    </div>
</template>
<script>

import {mapGetters} from 'vuex'
import QInputNumber from "src/components/QInputNumber.vue"

export default {
    name: "DestInputBox",
    model: {
        prop: 'amount',
        event: 'change'
    },
    props: {
        amount: {
            type: [Number, String],
            required: true
        },
        originCurrency: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapGetters(['exchange_rates']),
        destAmount: {
            get: function() {
                return this.amount
            },
            set: function(value) {
                this.$emit('change', value)
            }
        },
        dest_currencies() {
            let currencies = [];
            this.exchange_rates.forEach((item) => {
                if((! currencies.find(value => value.acronym === item.to.acronym) && (item.from.acronym === this.originCurrency) && item.active)) {
                    currencies.push(item.to)
                }
            })
            return currencies
        },
    },
    data() {
        return {
            destCurrency: null,
            displayOrgCurrencies: false,
            showTtip1: false
        }
    },
    methods: {
        findDefaultDestCurrency() {
            if (! this.exchange_rates.length) {
                return null
            }

            let last_to_currency = this.$q.cookies.has('last_to_currency') ? this.$q.cookies.get('last_to_currency') : this.dest_currencies[0].acronym

            if (! this.dest_currencies.some(rate => rate.acronym === last_to_currency)) {
                last_to_currency = this.dest_currencies[0].acronym
            }

            if (this.$route.params.currency) {
                last_to_currency = this.$route.params.currency
            }

            return this.dest_currencies.find(item => item.acronym === last_to_currency)
        },
        setDestCurrency() {
            this.destCurrency = this.findDefaultDestCurrency()
            this.$emit('destChanged', {origin_dest: 'dest', currency: this.destCurrency ? this.destCurrency.acronym : ''})
        },
        changeDestCurrency(currency) {
            if(this.destCurrency === currency) {
                return
            }
            this.destCurrency = currency
            this.$emit('destChanged', {origin_dest: 'dest', currency: currency.acronym})
        },
        tooltipClosed() {
            this.showTtip1 = false
            this.$q.localStorage.set('ttip_1', true)
        }
    },
    mounted() {
        this.setDestCurrency()

        setTimeout(() => {
            this.showTtip1 = true
        }, 2000)

        setTimeout(() => {
            this.showTtip1 = false
        }, 10000)
    },
    watch: {
        exchange_rates(val, old) {
            if(! old.length) {
                this.setDestCurrency()
            }
        },
        originCurrency(value) {
            this.setDestCurrency()
        }
    },
    components: {
        QInputNumber
    },
}
</script>
<style>

</style>
